import permissions from '@/enums/permissions';

const gatewayExpense = [
    {
        path: '/despesas-gateway',
        name: 'gateway-expense',
        component: () => import('@/views/pages/GatewayExpense/GatewayExpense.vue'),
        meta: {
            permissions: permissions.gatewayExpense,
        },
    },
];

export default gatewayExpense;
